import { render, staticRenderFns } from "./savedata.vue?vue&type=template&id=159be79a&scoped=true&"
import script from "./savedata.vue?vue&type=script&lang=js&"
export * from "./savedata.vue?vue&type=script&lang=js&"
import style0 from "./savedata.vue?vue&type=style&index=0&id=159be79a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159be79a",
  null
  
)

export default component.exports